import ApiClient from '../apiClient';
import { CommissionDayStat, CommissionMonthStat, WithdrawalRequest, PaginatedResponse, PaginationParams } from './types';

// ============ Request Params ============

export interface GetCommissionStatsParams extends PaginationParams {
  start_date: string; // YYYY-MM-DD format
  end_date: string;   // YYYY-MM-DD format
  type?: 'cpl' | 'revshare';
}

export interface GetCommissionMonthStatsParams extends GetCommissionStatsParams {
  of_model_id?: number;
  company_id?: number;
}

export interface GetWithdrawalRequestsParams extends PaginationParams {
  search?: string;
  id?: string;
  owner?: string;
  status?: 'pending' | 'paid' | 'cancel';
}

// ============ Response Types ============

export type CommissionStatsResponse = PaginatedResponse<CommissionDayStat>;
export type CommissionMonthStatsResponse = PaginatedResponse<CommissionMonthStat>;
export type WithdrawalRequestsResponse = PaginatedResponse<WithdrawalRequest>;

// ============ Finance API ============

export const financeApi = {
  /**
   * Получить статистику комиссий по дням
   */
  getCommissionStatsByDays: async (params: GetCommissionStatsParams): Promise<CommissionStatsResponse> => {
    const response = await ApiClient.get('/staff/stats/commission/by_days', { params });
    return response.data;
  },

  /**
   * Получить статистику комиссий по месяцам
   */
  getCommissionStatsByMonth: async (params: GetCommissionMonthStatsParams): Promise<CommissionMonthStatsResponse> => {
    const response = await ApiClient.get('/staff/stats/commission/by_month', { params });
    return response.data;
  },

  /**
   * Получить сумму CPL за указанный период
   */
  getCPLCurrentMonthAmount: async (params?: { start_date?: string; end_date?: string }): Promise<number> => {
    const response = await ApiClient.get('/staff/stats/commission/cpl_amount', { params });
    return response.data;
  },

  /**
   * Получить сумму RevShare за указанный период
   */
  getRefShareCurrentMonthAmount: async (params?: { start_date?: string; end_date?: string }): Promise<number> => {
    const response = await ApiClient.get('/staff/stats/commission/ref_share_amount', { params });
    return response.data;
  },

  /**
   * Получить список заявок на выплату
   */
  getWithdrawalRequests: async (params?: GetWithdrawalRequestsParams): Promise<WithdrawalRequestsResponse> => {
    const response = await ApiClient.get('/staff/partners/orders', { params });
    return response.data;
  },

  /**
   * Изменить статус заявки на выплату
   */
  changeWithdrawalStatus: async (orderId: string, status: 'paid' | 'pending' | 'cancel'): Promise<any> => {
    const response = await ApiClient.post(`/staff/partners/orders/${orderId}/change_status`, null, {
      params: { status }
    });
    return response.data;
  },
};

export default financeApi;
